// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GreetingBackground_wrapper__1Hsb4","card":"GreetingBackground_card__3R5y8"};